import createConverter from './lib/create_converter';
import CustomerTypingState from 'models/customer_typing_state';

export default createConverter(CustomerTypingState);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/customer_typing_state_converter.js